import { fetchChecklist } from "@/src/store/modules/setupChecklist";
import { getBridge } from "@/src/lib/bridge/bridge";
import { MessageType } from "@/src/lib/bridge/types";
import {
  trackPushPermissionGranted,
  trackPushSettingsAbandon,
  type PushEntry,
} from "./tracking";

/**
 * 因系统通知权限已被拒绝而跳转系统设置页后，等用户回到 App 时核对结果（PRD S1.6 / S1.7）：
 * 读到已授权 → `push_permission_granted(from_settings=true)` 并刷新清单；仍未授权 → `push_settings_abandon`。
 *
 * 跳转与返回之间组件可能已卸载，所以待核对的入口存在模块级变量里，由 Global Manager 在前台恢复时消费。
 */
let pendingEntry: PushEntry | null = null;

export function markPendingPushSettingsReturn(entry: PushEntry): void {
  pendingEntry = entry;
}

export function hasPendingPushSettingsReturn(): boolean {
  return pendingEntry !== null;
}

/** 经原生桥重新读取系统通知权限 */
export async function readSystemNotificationEnabled(): Promise<boolean> {
  const res = await getBridge().request(MessageType.NOTIFICATION_PERMISSION, {
    action: "check",
  });
  return Boolean((res?.data as { enabled?: boolean } | undefined)?.enabled);
}

/** @param isEnabled 重新读取系统通知权限（原生桥） */
export async function resolvePendingPushSettingsReturn(
  isEnabled: () => Promise<boolean>,
): Promise<void> {
  const entry = pendingEntry;
  if (!entry) {
    return;
  }
  pendingEntry = null;
  let enabled = false;
  try {
    enabled = await isEnabled();
  } catch {
    // 读取失败按未授权处理，不影响清单
  }
  if (enabled) {
    trackPushPermissionGranted(entry, true);
    await fetchChecklist(true);
  } else {
    trackPushSettingsAbandon(entry);
  }
}

/** 仅测试用 */
export function __resetPendingPushSettingsReturnForTest(): void {
  pendingEntry = null;
}
